module.exports = __webpack_public_path__ + "img/introduce-icon1.66865a4a.png";